var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm25.702 13.311V24.254h3.604l.478-4.5h-4.082l.006-2.251c0-1.174.111-1.803 1.797-1.803h2.253v-4.5h-3.605c-4.33 0-5.854 2.183-5.854 5.854v2.701H17.6v4.5h2.7V37.31h5.402z"}));
}

Facebook.displayName = "Facebook";

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Facebook;

Facebook.default = Facebook;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 1089
// module chunks = 22